import { Menu, LogOut, ChevronDown, UserCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import CurrencyTicker from "@/components/layout/CurrencyTicker";
import GlobalSearch from "@/components/layout/GlobalSearch";
import NotificationBell from "@/components/layout/NotificationBell";

const initials = (name = "") => name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 pl-2 pr-1.5 h-10 rounded-md hover:bg-slate-100 transition-colors" data-testid="user-menu-trigger">
          <div className="h-8 w-8 rounded-full bg-slate-900 text-white grid place-items-center text-xs font-bold">{initials(user.name)}</div>
          <div className="hidden md:block text-left leading-tight">
            <div className="text-[13px] font-semibold text-slate-900" data-testid="user-menu-name">{user.name}</div>
            <div className="text-[11px] text-blue-700 font-medium" data-testid="user-menu-role">{user.role_name}</div>
          </div>
          <ChevronDown className="h-4 w-4 text-slate-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel>
          <div className="text-sm font-semibold">{user.name}</div>
          <div className="text-xs text-slate-500 font-normal">{user.email}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem disabled><UserCircle2 className="h-4 w-4 mr-2" />{user.title || user.role_name}</DropdownMenuItem>
        <DropdownMenuItem onClick={async () => { await logout(); navigate("/giris"); }} data-testid="logout-button" className="text-rose-600">
          <LogOut className="h-4 w-4 mr-2" />Çıkış Yap
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default function Topbar({ onMenu }) {
  return (
    <header className="sticky top-0 z-40 h-16 bg-white/90 backdrop-blur-md border-b border-slate-200 px-3 md:px-6 flex items-center gap-3" data-testid="topbar">
      <Button variant="ghost" size="icon" className="lg:hidden" onClick={onMenu} data-testid="sidebar-toggle"><Menu className="h-5 w-5" /></Button>
      <GlobalSearch />
      <div className="flex-1 hidden xl:block" />
      <CurrencyTicker />
      <NotificationBell />
      <UserMenu />
    </header>
  );
}
